export default () => {
  const headerSticky = () => {
    $(window).scroll(function () {
      const heightBody = $(window).scrollTop(),
        bannerSticky = $(".js-show-banner"),
        smartBanner = $(".smartbanner-show"),
        ie11 = $(".is-ie11"),
        phoneBreakpoint = 640,
        tabletBreakpoint = 960,
        desctopBreakpoint = 1280;

      var windowWidth = window.innerWidth;

      if (bannerSticky.length) {

        if (windowWidth < phoneBreakpoint) {
          var heightBanner = 124;
        } else if (windowWidth < tabletBreakpoint) {
          var heightBanner = 100;
        } else if (windowWidth < desctopBreakpoint) {
          var heightBanner = 76;
        } else {
          if (ie11.length) {
            var heightBanner = 40;
          } else {
            var heightBanner = 52;
          }
        }

        if (smartBanner.length) {
          var heightBanner = 182;
        }

        if (heightBody > heightBanner) {
          bannerSticky.addClass("fixed-sticky");
        } else {
          bannerSticky.removeClass("fixed-sticky");
        }
      }
    });
  };

  const hiddenBaner = () => {
    const banner = $(".banner-header");
    const bannerWrapper = $(".js-show-banner");

    if (banner.length) {
      $(".banner-close").on("click", function (event) {
        event.preventDefault();
        banner.addClass("is-hidden");
        bannerWrapper.removeClass("js-show-banner");
      });
    };
  };

  $(window).resize(function () {
    headerSticky();
  });

  headerSticky();
  hiddenBaner();
}
